import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { UPDATE_EMPLOYEE_COMPANY_ROLES, useCompanyRolesService } from '../../shared/companyRolesService';
import { ModalFormButton } from 'framework/form';
import { useListContext } from 'framework/list';
import CompanyRolesInput from '../../shared/inputs/CompanyRolesInput';
import { useIsMyProfile } from 'domain/shared/employee';
import { useAuthorization } from 'framework/authorization';

const AddCompanyRoleToEmployeeButton = () => {
  const isMyProfile = useIsMyProfile();
  const { isGranted } = useAuthorization();
  const { addRoleToEmployee, getValidationSchema } = useCompanyRolesService();
  const { reloadData } = useListContext();

  if (isMyProfile || !isGranted(UPDATE_EMPLOYEE_COMPANY_ROLES)) {
    return null;
  }

  return (
    <ModalFormButton
      formTitle="New role"
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        execute: () => {
          reloadData!();
        },
        message: 'You are awesome! The role has been successfully added.',
      }}
      label={<AddIcon fontSize="small" />}
      submitFormFunc={addRoleToEmployee}
      paperStyles={{
        background: 'var(--mui-palette-background-paper)',
      }}
      sxButton={{
        minWidth: 'auto',
        p: 0,
        mr: '9px',
      }}
    >
      <CompanyRolesInput label="Company role" source="role" />
    </ModalFormButton>
  );
};

export default AddCompanyRoleToEmployeeButton;
